/**
 * Class name utility - combines class names and handles conditional classes
 * Simple implementation for combining Tailwind classes
 */

export function cn(...classes: (string | undefined | null | false)[]): string {
  return classes.filter(Boolean).join(' ');
}
